import { useEffect, useState } from 'react'
import mainLogo from '../assets/mpfp-logo.png'
import allainceConnectLogo from '../assets/allience-connect.png'
import './Login.scss'
import { LoginService, getCurrentUserDetails } from '../Services/LoginService'
import { useNavigate } from '@tanstack/react-location'
import { useAuth } from '../utils/AuthContext'
import { usePostPayload } from '../utils/PostPayloadContext'
import { getUserEulaStatus } from '../Services/WidgetService'
import { getEnvironment } from '../Environment'
import EulaDailog from '../EULAModal/EulaDailog'
import { show as showNiceModal } from '@ebay/nice-modal-react'

const environment = getEnvironment()

const LoginComponent = () => {
  const { setIsAuthenticated } = useAuth()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [username, setUserName] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [acceptTheEula, setAcceptTheEula] = useState<boolean>(false)
  const [showEulaWarning, setShowEulaWarning] = useState<boolean>(false)

  const navigate = useNavigate()
  const { setLoader } = usePostPayload()

  useEffect(() => {
    setLoader(true)
    getCurrentUserDetails()
      .then((user) => {
        if (user && user.username) {
          setIsAuthenticated(true)
          navigate({ to: '/' })
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoader(false)
      })
  }, [navigate, setIsAuthenticated, setLoader])

  const handleLogin = async () => {
    if (!username.length) {
      setErrorMessage('Please Enter a ScreenName')
      return
    }
    if (!password.length) {
      setErrorMessage('Password is required for Login')
      return
    }
    setLoader(true)
    try {
      await LoginService({
        userName: username,
        password,
      })
      setIsAuthenticated(true)
      navigate({ to: '/', replace: true })
    } catch (error: any) {
      setErrorMessage(error.message)
      setLoader(false)
    }
  }

  const checkUserEulaStatus = async (fromOnBlur?: boolean) => {
    if (!username) return
    try {
      const status = await getUserEulaStatus(environment.checkEulaUrl, username)

      const accepted = status?.eulaStatus ?? false
      setAcceptTheEula(accepted)
      setShowEulaWarning(!accepted)

      if (!fromOnBlur && accepted) {
        handleLogin()
      }
    } catch (error: any) {
      if (error?.response?.data?.code === 'USER_1001') {
        setErrorMessage(error?.response?.data?.message)
      }
    }
  }

  return (
    <div>
      <div className="loginFormParent">
        <p className="welcome-text">Welcome to MyPlace4Parts</p>
      </div>
      <div className="loginFormParent">
        <div className="loginContainer">
          <div className="loginForm">
            <img className="main-logo" alt="logo" src={mainLogo} />
            <form className="formClass">
              <input
                className="input_username"
                type="text"
                id="username"
                name="name"
                value={username}
                placeholder="Screen name"
                onChange={(e) => setUserName(e?.target.value)}
                onBlur={() => checkUserEulaStatus(true)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    checkUserEulaStatus(false)
                  }
                }}
              />
              <input
                className="input_password"
                type="password"
                id="password"
                name="password"
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e?.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    checkUserEulaStatus(false)
                  }
                }}
              />

              {showEulaWarning && (
                <div className="eula-section">
                  <input
                    type="checkbox"
                    id="eula"
                    className="eula-checkbox"
                    checked={acceptTheEula}
                    onChange={(e) => setAcceptTheEula(e.target.checked)}
                  />
                  <label htmlFor="eula">
                    I accept the{' '}
                    <button
                      type="button"
                      className="eula-link"
                      onClick={() => {
                        showNiceModal(EulaDailog)
                      }}
                    >
                      End User License Agreement
                    </button>
                  </label>
                </div>
              )}

              <input
                className="log_btn_signIn"
                type="button"
                value={
                  showEulaWarning && !acceptTheEula
                    ? 'PLEASE REVIEW AND ACCEPT EULA ABOVE'
                    : 'SIGN IN'
                }
                id="submit-button"
                disabled={showEulaWarning && !acceptTheEula}
                onClick={() => {
                  if (acceptTheEula) {
                    handleLogin()
                  } else {
                    checkUserEulaStatus(false)
                  }
                }}
              />
              <p className="errormessages_cls">{errorMessage}</p>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-block">
        <p className="signin-txt">Please sign in to access MyPlace4Parts.</p>
        <p
          className="forgot-txt"
          onClick={() =>
            navigate({
              to: '/forgot-password',
            })
          }
        >
          Forgot Password
        </p>
        <p className="assistance-txt">
          If you did not receive an email containing login information, contact
          your Parts Supplier.
        </p>
        <a className="transition-txt">
          <img className="sub-logo" alt={'logo'} src={allainceConnectLogo} />
        </a>
      </div>
    </div>
  )
}

export default LoginComponent
